import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;

  > div {
    flex: 1;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
  align-items: center;
  justify-content: center;
`;

export const LoginLeftWrapper = styled.div`
  border-right: 1px solid #e5e7eb;
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoginLeftContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  width: 400px;

  > img {
    width: 179px;
    height: 48px;
  }
`;

export const LoginTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  min-width: 440px;
  color: #111827;
  font-family: "Pretendard";
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 33.5px; /* 119.643% */
  letter-spacing: -0.56px;

  > .sub {
    color: #6b7280;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px; /* 118.75% */
  }
`;

export const LoginInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  color: #374151;
  font-family: "Pretendard";
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 15.5px; /* 119.231% */
  position: relative;

  > input {
    border-radius: 8px;
    border: 1px solid #d1d5db;
    display: flex;
    height: 42px;
    width: 440px;
    align-items: center;
    outline: none;
    padding: 0 12px;
    box-sizing: border-box;
    color: #111827;
    font-family: "Pretendard";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > img {
    position: absolute;
    right: 12px;
    cursor: pointer;
    bottom: 12px;
  }
`;

export const LoginInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LoginButton = styled.div`
  border-radius: 8px;
  background: #d4f554;
  display: flex;
  width: 440px;
  height: 48px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #121212;
  font-family: "Pretendard";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px; /* 118.75% */
  cursor: pointer;
`;

export const LoginBorder = styled.div<{ $isRotate?: boolean }>`
  border-width: 1px;
  border-style: solid;
  border-color: currentcolor;
  border-image: linear-gradient(
      90deg,
      rgb(255, 255, 255) 0%,
      rgb(217, 217, 217) 100%
    )
    1 / 1 / 0 stretch;
  width: 196px;
  transform: ${({ $isRotate }) => ($isRotate ? "rotate(180deg)" : "none")};
`;

export const LoginBorderWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  color: #b7b7b7;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.32px;
`;

export const LoginOtherLoginWRapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  color: #121212;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.32px;
  width: 440px;
`;

export const LoginOtherLoginButtonWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  > img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`;
